import RequisiteModal from './RequesiteModal';

export default RequisiteModal;
